const productDb = [
//snacks-and-dairy|dairy-products
{
img: `https://drive.google.com/uc?id=147qFITipBUnH9d77TRV-Y8QuulNF7HSB`,
name: `Assorted Cheeses Slices(200g)`,
disc: `This item was collected from Footloose Archives Trend Crate its sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `30.00`,
    categories: [`green-crate`],
},
//snacks-and-dairy|ready-meals
{
img: `https://drive.google.com/uc?id=188is7rjiLdnnaDkWNhl1HNnZVT4kbpo8`,
    name: `Salted Butter(500g)`,
    disc: `This item was collected from the Footloose Archives Trend Crate its Sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `60.00`,
    categories: [`green-crate`],
},
//snacks-and-dairy|snacks
{
img: `https://drive.google.com/uc?id=18BOfqVRPqUZ0oSbKjR04dHG6kblkkf-i`,
    name: `Fresh Milk (2.l)`,
    disc: `This item was collected from the Footloose Archives Trend Crate its Sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `28.00`,
    categories: [`green-crate`],
},
//fish
{
img: `https://drive.google.com/uc?id=18uZt6tKmqsa6yfYM7CHrlo68M6N6lkcd`,
name: `Fish Ribbon(400g)`,
disc: `This item was collected from the Footloose Archives Trend Crate its Sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `24.00`,
    categories: [`green-crate`],
},
{
img: `https://drive.google.com/uc?id=18iO2NG3_wdvbYoLHypQat-4ZUK89cRaH`,
name: `Fish Snoek(300g)`,
disc: `This item was collected from the Footloose Archives Trend Crate its Sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `21.00`,
    categories: [`green-crate`],
},
//chicken

{
img: `https://drive.google.com/uc?id=19brkRmqqR1dFiJ4--dQqZXSeZU7Qd7W0`,
name: `Chicken Drumsticks(490g)`,
disc: `This item was collected from the Footloose Archives Blue Crate its sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `38.00`,
    categories: [`blue-crate`],
},{
img: `https://drive.google.com/uc?id=190ePq6lOs4MAdvLP5ghOrKXl569xCl5Z`,
name: `Chicken Wings(490g)`,
disc: `This item was collected from the Footloose Archives Blue Crate its sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `27.00`,
    categories: [`blue-crate`],
},
{
img: `https://drive.google.com/uc?id=1-OGwseFkcMSvztV2eBhuQS6r2FLcBpLZ`,
name: `Polony(3kg)`,
disc: `This item was collected from Footloose Archives Red Crate its sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `80.00`,
    categories: [`red-crate`],
},
//pork

{
img: `https://drive.google.com/uc?id=1A9MCuvNbpay1drwh1HF6EfYr9AF0Jznd`,
name: `Pork Chops(490g)`,
disc: `This item was collected from the Footloose Archives Blue Crate its sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `38.00`,
    categories: [`blue-crate`],
},{
img: `https://drive.google.com/uc?id=19nY_HkV2wzACCpapj6Yc3K4b6cSlCWmy`,
name: `Pork Russian(1kg)`,
disc: `This item was collected from Footloose Archives Red Crate its sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `43.00`,
    categories: [`red-crate`],
},
//lamp
{
img: `https://drive.google.com/uc?id=1Ae_scwVitUd2o1WTm6E1NQxrXDaRIlDY`,
name: `Boere Wors(490g)`,
disc: `This item was collected from the Footloose Archives Trend Crate its Sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `32.00`,
    categories: [`green-crate`],
},{
img: `https://drive.google.com/uc?id=1AZM6XxEf1WyuwTg60eed-DI9FJ3j8kcO`,
name: `Lamb Chops(490g)`,
disc: `This item was collected from the Footloose Archives Blue Crate its sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `38.00`,
    categories: [`blue-crate`],
},
//Beef

{
img: `https://drive.google.com/uc?id=1BI4KTSbSxS3twSBQRP_EQfbHrJQj5hqD`,
name: `Beef Chakalaka Wors(490g)`,
disc: `This item was collected from the Footloose Archives Trend Crate its Sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `30.00`,
    categories: [`green-crate`],
},
{
img: `https://drive.google.com/uc?id=1B5PvpJT6iEHpCGbgGXed4wz9sd8tnwvA`,
name: `Minced Meat(490g)`,
disc: `This item was collected from the Footloose Archives Trend Crate its Sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `31.00`,
    categories: [`green-crate`],
},
{
img: `https://drive.google.com/uc?id=1Axd797-s-HZo19SxHG4i8uAHkmNHcaV-`,
name: `Beef Short Sirloin(490g)`,
disc: `This item was collected from the Footloose Archives Blue Crate its sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `48.00`,
    categories: [`blue-crate`],
},
//Fruits_&_Vegetables
{
img: `https://drive.google.com/uc?id=1Bg8_vrBMzBX8DUS44IXDqz8SJrlpBrW-`,
    name: `Carrots (5kg)`,
    disc: `This item was collected from the Footloose Archives Blue Crate its sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `35.00`,
    categories: [`blue-crate`],
},
{
img: `https://drive.google.com/uc?id=1Blc2KvpPeKZOShX0t5Zc7YGqaM04yrfn`,
    name: `Corn (750g)`,
    disc: `This item was collected from the Footloose Archives Blue Crate its sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `32.00`,
    categories: [`blue-crate`],
},

{
img: `https://drive.google.com/uc?id=1C-Lomd1Don_y058XojXZaTopMBGRhNRv`,
    name: `Pepper`,
    disc: `This item was collected from Footloose Archives Red Crate its sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `40.00`,
    categories: [`red-crate`],
},

{
img: `https://drive.google.com/uc?id=1C-H17iZT4bPJsvF2ZzPnNKUmO9GbB4KZ`,
name: `Onions (5kg)`,
    disc: `This item was collected from Footloose Archives Red Crate its sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `40.00`,
    categories: [`red-crate`],
},

{
img: `https://drive.google.com/uc?id=1C1U6DI8ku16J_CXiE5dr3sQt4KTRd6yp`,
    name: `Potatoes(5kg)`,
    disc: `This item was collected from Footloose Archives Red Crate its sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `45.00`,
    categories: [`red-crate`],
},
{
img: `https://drive.google.com/uc?id=1BfhTrpPBgACIMNyUlRn1bv8jXnwdoo3Y`,
name: `Cabbage`,
disc: `This item was collected from the Footloose Archives Blue Crate its sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `25.00`,
    categories: [`blue-crate`],
},

{
img: `https://drive.google.com/uc?id=1DPU2YXpY1gf9edZBkiO7WVx7dOZhNM6v`,
    name: `Apples(1kg)`,
    disc: `This item was collected from Footloose Archives Red Crate its sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `33.00`,
    categories: [`red-crate`],
},
{
img: `https://drive.google.com/uc?id=1D8QrMqIMB1C9mzJpOpAlqzxsuTVVkCHA`,
    name: `Oranges(1kg)`,
    disc: `This item was collected from Footloose Archives Red Crate its sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `21.00`,
    categories: [`red-crate`],
},

{
img: `https://drive.google.com/uc?id=1DMvvXn4_EBAe4AWii1rnqAybGS45nlWj`,
name: `Avocado(1kg)`,
disc: `This item was collected from the Footloose Archives Blue Crate its sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `50.00`,
    categories: [`blue-crate`],
},
{
img: `https://drive.google.com/uc?id=1DJitnlgGJEpJv9usd9CB2zPTQ_wGL2Ly`,
name: `Bananas(1kg)`,
disc: `This item was collected from Footloose Archives Red Crate its sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `23.00`,
    categories: [`red-crate`],
},
{
img: `https://drive.google.com/uc?id=12hT1lJTNbAWG5CxQeIT4_roB-t7E5S3H`,
name: `Eggs(24)`,
disc: `This item was collected from the Footloose Archives Trend Crate its Sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `50.00`,
    categories: [`green-crate`],
},
{
img: `https://drive.google.com/uc?id=1CWtx8nNsNl0ro2_NLZJDRKdBsxD5nALu`,
name: `Tomatoes(3kg)`,
disc: `This item was collected from Footloose Archives Red Crate its sales terms can be found on their Website by clicking the link below,its price is valid from the 1st of August till the 18th August 2020`,
    map: `https://camelthornetree.firebaseapp.com/health-crate/`,
    price: `45.00`,
    categories: [`red-crate`],
},

];
// eslint-disable-next-line import/prefer-default-export
export function get({ filter = {}, limit, page = 1 }) {
  const pageInt = parseInt(page, 10);

  return new Promise((resolve) => {
    setTimeout(() => {
      let result = productDb;
      let filteredResultCount = result.length;

      if (filter.category) {
        result = result.filter(x => x.categories.includes(filter.category));
        filteredResultCount = result.length;
      }

      if (limit) {
        const start = (pageInt - 1) * limit;
        const end = start + limit;
        result = result.slice(start, end);
      }

      resolve({
        data: result,
        meta: {
          pageCount: Math.ceil(filteredResultCount / limit),
        },
      });
    }, 500);
  });
}
